/**
 * Rounds progression for display (3 decimal by default).
 * Values that become 0.0 / -0.0 at that precision are normalized to 0.
 */
export const roundProgressionForDisplay = (progression: number, fractionDigits = 3): number => {
  if (progression == null) {
    return null
  }

  const rounded = Number(progression.toFixed(fractionDigits))
  return rounded === 0 ? 0 : rounded
}
